import { useSupabaseLoader } from "../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import { SupabaseAccountService } from "../../generic/server/supabase-account-service";
import type { ChannelName } from "../types";

export function useEnabledChannels(): UseSupabaseLoaderState<ChannelName[]> {
  return useSupabaseLoader(async ({ supabase, account_id }) => {
    return await new SupabaseAccountService(supabase).getEnabledChannels(account_id);
  }, []);
}
